<!-- vue2模拟teleport功能 -->
<!-- 参考: https://article.juejin.cn/post/7224051399256916029 -->
<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "teleport",
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const toEl = document.querySelector(this.to);
    if (toEl) {
      toEl.appendChild(this.$el);
    }
  },
  destroyed() {
    const toEl = document.querySelector(this.to);
    if (toEl) {
      toEl.removeChild(this.$el);
    }
  },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
</style>
